<template>
  <div id="app" class="container">
    <h4 class="text-center header">VUFindAny-#Frame</h4>
    <SearchBar @send="getData" />
    <ImageList v-bind:img="img" v-bind:count="count" />
  </div>
</template>

<script>
import SearchBar from "./components/SearchBar";
import ImageList from "./components/ImageList";

import API from "./API";

export default {
  name: "App",
  components: {
    SearchBar,
    ImageList
  },
  data() {
    return {
      img: [],
      count: null
    };
  },
  methods: {
    async getData(value) {
      const info = await API.get("search/photos", {
        params: { query: value }
      });
      this.img = info.data.results;
      this.count = this.img.length;
    }
  }
};
</script>

<style>
#app {
  margin-top: 10px;
}
.header {
  color: white;
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",monospace;
}
</style>
